import { getAllLogs, getAllThreats, getAllIpEnrichments, getAllImports } from '../services/storage.js';
import { exportHTML, exportCSV, downloadFile } from '../services/exporter.js';
import './toast-container.js';

const template = document.createElement('template');
template.innerHTML = `
  <div class="section-header">
    <h1>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:8px">
        <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
      Export Reports
    </h1>
  </div>

  <div class="export-options">
    <div class="export-card" data-format="html">
      <div class="export-icon">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      </div>
      <div class="export-name">HTML Report</div>
      <div class="export-desc">Formatted threat analysis report with summary stats and threat table</div>
    </div>
    <div class="export-card" data-format="csv">
      <div class="export-icon">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/>
        </svg>
      </div>
      <div class="export-name">CSV Export</div>
      <div class="export-desc">Raw data export with all enrichment and classification fields</div>
    </div>
  </div>

  <div id="export-status"></div>
`;

export class ExportPanel extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = template.innerHTML;
  }

  connectedCallback() {
    this.querySelectorAll('.export-card').forEach(card => {
      card.addEventListener('click', () => this.doExport(card.dataset.format));
    });
  }

  async doExport(format) {
    const statusEl = this.querySelector('#export-status');
    statusEl.innerHTML = '<div class="loading"><div class="spinner"></div> Preparing export...</div>';

    try {
      const logs = await getAllLogs();
      const threats = await getAllThreats();
      const enrichments = await getAllIpEnrichments();
      const imports = await getAllImports();

      if (format === 'html') {
        const html = exportHTML({ logs, threats, enrichments, imports });
        downloadFile(html, `threatscope-report-${new Date().toISOString().slice(0, 10)}.html`, 'text/html');
        statusEl.innerHTML = '';
        window.showToast('HTML report downloaded', 'success');
      } else if (format === 'csv') {
        const csv = exportCSV({ logs, threats, enrichments });
        downloadFile(csv, `threatscope-export-${new Date().toISOString().slice(0, 10)}.csv`, 'text/csv');
        statusEl.innerHTML = '';
        window.showToast('CSV export downloaded', 'success');
      }
    } catch (e) {
      statusEl.innerHTML = '';
      window.showToast(`Export failed: ${e.message}`, 'error');
    }
  }

}

customElements.define('export-panel', ExportPanel);
